// extracted by mini-css-extract-plugin
export var body = "_33-1";
export var bodyPadded = "_33-2";
export var chevron = "_33-4";
export var chevronOpen = "_33-5";
export var header = "_33-0";
export var icon = "_33-3";